import styled from "styled-components";

export const AltSlickContainer = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const AltSlickSlideContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  margin: 0 auto;
  overflow: hidden;
  width: 100%;
  padding: 0 3rem 0 0.5rem;
`;

export const AltSlickInrSlider = styled.div`
  white-space: nowrap;
  width: 100%;
  transition: ease 1000ms;
`;

export const AltSlickInrSlidWrap = styled.div`
  display: inline-block;
  background-color: #fff;
`;

export const AltSlickLeftBtn = styled.button(
    props => `
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        left: 1px;
        border: none;
        outline: none;
        width: 48px;
        height: 48px;
        border-radius: 50%;
        background-color: rgba(20, 24, 35, 0.2);
        cursor: pointer;
        background: #fff;
        transform: rotate(180deg);
        box-shadow: 0px 1px 4px rgb(0 0 0 / 25%);
        &:hover{
            background-color: #e9eff5;
        }
`);

export const AltSlickRightBtn = styled.button(
    props => `
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        right: 1px;
        border: none;
        outline: none;
        width: 48px;
        height: 48px;
        border-radius: 50%;
        background-color: rgba(20, 24, 35, 0.2);
        cursor: pointer;
        background: #fff;
        box-shadow: 0px 1px 4px rgb(0 0 0 / 25%);
        &:hover{
          background-color: #e9eff5;
      }
`);
